// src/components/ui/elements/UnderlineButton.tsx
import React, { forwardRef } from "react";

interface UnderlineButtonProps {
  children: React.ReactNode;
  isActive: boolean;
  onClick?: () => void;
  className?: string;
  activeColor?: string;
  inactiveColor?: string;
}

export const UnderlineButton = forwardRef<HTMLButtonElement, UnderlineButtonProps>(
  (
    {
      children,
      isActive,
      onClick,
      className = "",
      activeColor = "bg-purple-500",
      inactiveColor = "bg-purple-500",
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        onClick={onClick}
        className={`relative group inline-flex items-center gap-2 px-2 py-1 transition-colors duration-300 focus:outline-none ${className}`}
      >
        {children}
        <span
          className={`
            absolute bottom-0 left-0 h-0.5
            transition-all duration-300 ease-out
            ${isActive ? "w-full" : "w-0 group-hover:w-full"}
            ${isActive ? activeColor : inactiveColor}
          `}
        />
      </button>
    );
  }
);

UnderlineButton.displayName = "UnderlineButton";